import { getSenderEmail } from "../../utils/mailUtils";

/**
 * Shared email signature template for all email templates
 */
export const getEmailSignature = (baseUrl: string = window.location.origin) => {
    const senderEmail = getSenderEmail();
    return `<div>
  <div dir="ltr" class="gmail_signature" data-smartmail="gmail_signature">
    <div dir="ltr">
      <div dir="ltr">
        <div dir="ltr">
          <div dir="ltr">
            <div dir="ltr">
              <div dir="ltr">
                <div dir="ltr">
                  <div dir="ltr">
                    <div dir="ltr">
                      <div dir="ltr">
                        <div dir="ltr">
                          <div><br></div>
                          <div>Met vriendelijke groet,</div>
                          <div>Kristel</div>
                          <div><br></div>
                          <div><i>Team Ridder en de Prins</i></div>
                          <div><i>Anouk, Kristel, Ludo en Yorick</i></div>
                          <div>
                            <div style="font-family:arial;font-size:small"><br></div>
                            <div style="font-family:arial;font-size:small"><br></div>
                          </div>
                          <div><b><font color="#38761d">Ridder en de Prins Entertainment<br></font></b></div>
                          <div><font face="arial, sans-serif" color="#38761d"><b>030 - 207 702 7</b></font><font color="#6aa84f"><br></font></div>
                          <div><a href="mailto:${senderEmail}" target="_blank"><font color="#6aa84f">${senderEmail}</font></a><br></div>
                          <div><a href="https://www.youtube.com/watch?v=nvkMp7pF-4U" target="_blank"><font color="#6aa84f">Videoclip: 'Sinterklaasje, kom maar binnen'</font></a></div>
                          <div><img width="200" style="height: auto;" src="${baseUrl}/RedP_Logo.png"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`;
};

export const EMAIL_SIGNATURE = getEmailSignature();